export enum IntegrationStatusNum {
  TEST_PENDING = 1,
  TEST_IN_PROGRESS = 2,
  TEST_SUCCESS = 3,
  TEST_FAILED = 4,
  PUBLISHED = 5,
  ERROR = 6,
  DELETED = 7,
}
